import type { RouteRecordRaw } from 'vue-router';

export const battleSetsRoutes: RouteRecordRaw[] = [
  {
    path: '/sets',
    name: 'battleSets',
    component: () => import('./pages/BattleSetsList.vue'),
    meta: {
      requiresAuth: true,
      title: 'Battle Sets',
    },
  },
  {
    path: '/sets/:id',
    name: 'battleSetDetail',
    component: () => import('./pages/BattleSetDetail.vue'),
    meta: {
      requiresAuth: true,
      title: 'Battle Set Details',
    },
  },
];
